import React from 'react';
import { useLocation } from 'react-router-dom';
import LegacyFooter from './LegacyFooter';
import PolarisFooter from './PolarisFooter';
import { HOME } from '../../../helpers/routes';
import { usePolaris } from '../../../helpers/polaris';

const PageFooter = (props) => {
  const { pathname } = useLocation();
  const isGlobalNav = usePolaris();
  const isDevicesHomeRoute = pathname === HOME;

  if (isGlobalNav === undefined) return null;
  if (isDevicesHomeRoute && isGlobalNav) return <PolarisFooter slim={false} />;
  if (!isGlobalNav) return <LegacyFooter {...props} />;
  return <PolarisFooter {...props} />;
};

export default PageFooter;
